module.exports = __webpack_public_path__ + "media/newstyle/images/icon-questionmark-red-166267769716a7d205730a71e4a3f991.svg";